import { productDetails } from '@legacyUrls';

// Auth
export const login = '/login';
export const loginPhone = '/login/phone';
export const loginPhoneVerify = '/login/phone/verify';
export const registration = '/login/registration';
export const socialRegistration = '/login/registration/:socialProvider';
export const logout = '/logout';
export const facebookLogin = '/login/facebook';
export const googleLogin = '/login/google';

export const addNewProduct = '/new';
export const editProduct = '/items/:productId/edit';

// Login passwords
export const createPassword = '/login/create-password';
export const choosePasswordWithEmailCode = '/login/choose-password/:emailActivationKey';
export const choosePassword = '/login/choose-password';
export const resetPasswordWithEmailCode = '/login/reset-password/:emailActivationKey';
export const resetPassword = '/login/reset-password';

// Phone verification
export const phoneVerification = '/phone-verification';

// Chat
export const dialogsList = '/msg';
export const dialogDetails = '/msg/:threadId';
export const dialogThanks = '/msg/:threadId/thanks';
export const dialogNewDirect = '/msg/new/:username';

// Brave
export const braveClosedPage = '/brave/closed_page';

// My reviews
export const memberReviewRequests = '/my/review-requests';
export const memberReview = '/my/reviews';
export const memberReviewRequest = '/my/:role(review-seller|review-buyer)/:threadId';
export const memberReviewSeller = '/my/review-seller/:threadId';
export const memberReviewBuyer = '/my/review-buyer/:threadId';
export const memberReviewRequestThanks = '/my/:role(review-seller|review-buyer)/:threadId/thanks';
export const memberAsSellerReviews = '/member/:username/reviews?t=s';
export const memberAsBuyerReviews = '/member/:username/reviews?t=b';

// My subscriptions
export const mySubscribedBrandsProducts = '/my/subscribed-brands/products';
export const mySubscribedUsersProducts = '/my/subscribed-users/products';
export const mySubscribedSavedSearch = '/my/subscribed-searches';
export const myFavorites = '/my/favourites';

// My settings
export const memberProfile = '/my/settings';
export const memberSettingsShopName = '/my/settings/shop/name';
export const memberSettingsShopDelivery = '/my/settings/shop/delivery';
export const memberSettingsPaymentMethod = '/my/settings/shop/payment-method';
export const memberSettingsSafePaymentMethods = '/my/settings/shop/safe-payment';
export const memberSettingsReturnTerms = '/my/settings/shop/return';
export const memberSettingsShop = '/my/settings/shop';
export const memberSettingsNotifications = '/my/settings/notifications';
export const memberSettingsPaymentsHistory = '/my/settings/payments';
export const memberSettingsMsgTemplates = '/my/settings/mt';

// My achievements
export const mySuperSellerAchievements = '/my/achievements/super-seller';

// My wallet
export const myWallet = '/my/wallet';
export const myWalletAddNewPaymentCard = `${myWallet}/new-card`;

// Card verification callback
export const cardVerificationCallback = '/card-verification-callback';

// My clothes
export const myClothes = '/my/clothes';
export const myActiveClothes = '/my/clothes/active';
export const myPromotedClothes = '/my/clothes/promoted';
export const myModeratedClothes = '/my/clothes/moderated';
export const myDeclinedClothes = '/my/clothes/declined';
export const myReservedClothes = '/my/clothes/reserved';
export const myInactiveClothes = '/my/clothes/inactive';
export const mySoldClothes = '/my/clothes/sold';
export const myDeletedClothes = '/my/clothes/deleted';

// My potential deals
export const myPotentialDeals = '/my/potential-sales';
export const myConfirmedPotentialDeals = '/my/potential-sales/confirmed';

// My discount promotions
export const myDiscountPromotions = '/my/discount-promotions';
export const myDiscountPromotionsParticipates = `${myDiscountPromotions}/sales`;
export const myDiscountPromotionsProductsSelect = `${myDiscountPromotionsParticipates}/:saleId(\\d+)`;

// My sales
export const mySalesIndex = '/my/sales';
export const mySalesWithStatus = '/my/sales/:orderStatus';
export const mySalesWithStatusAndPage = '/my/sales/:orderStatus/:page';
export const saleDetails = '/my/sales/sale/:id';

// My purchases
export const myPurchasesIndex = '/my/purchases';
export const myPurchasesWithStatus = '/my/purchases/:orderStatus';
export const myPurchasesWithStatusAndPage = '/my/purchases/:orderStatus/:page';
export const purchaseDetails = '/my/purchases/purchase/:id';

// My subscribers notification
export const myMessageToSubscribers = '/my/message-to-subscribers';

// My SMART
export const smart = '/my/smart';
export const smartSettings = '/my/smart/settings';

// Member
export const publicMemberProfile = '/member/:username';
export const memberReviews = '/member/:username/reviews';
export const aboutMemberProfile = '/member/:username/about';
export const memberSocialPosts = '/member/:username/posts';
export const memberSocialPostsLiked = '/member/:username/posts/liked';
export const memberSocialPostsSaved = '/member/:username/posts/saved';

// New product promotions
export const addNewProductPromotionPackages = '/new/:productId/promotion-packages';
export const addNewProductThanks = '/new/:productId/thanks';
export const addNewProductThanksWithVerification = '/new/thanks_verification';

// Notifications
export const notificationsList = '/notification';
export const notificationsDetails = '/notification/:id';

// Promotion
export const promotions = '/promote/:productId(\\d+)';
export const promotionPackagesPaymentMethods = '/promote/:productId(\\d+)/packages/:packageId(\\d+)/payments';
export const promotionServicesPaymentMethods = '/promote/:productId(\\d+)/promotions/:promotionId(\\d+)/payments';
export const promotionPackagesPayment = '/promote/:productId(\\d+)/packages/:packageId(\\d+)/pay';
export const promotionPackagesPaymentAnotherCard = `${promotionPackagesPayment}/another-card`;
export const promotionServicesPayment = '/promote/:productId(\\d+)/promotions/:promotionId(\\d+)/pay';
export const promotionServicesPaymentAnotherCard = `${promotionServicesPayment}/another-card`;

// Balance payment
export const balanceRefillForm = '/balance/payment';
export const paymentBalance = '/balance/payment/:amount/pay';
export const paymentBalanceAnotherCard = `${paymentBalance}/another-card`;

// Smart payment
export const smartPayment = '/smart/payment/:planId/pay';
export const smartPaymentAnotherCard = `${smartPayment}/another-card`;

// Checkout buyer
// Warning: don't forget to add 'from' param for analytics proposal
export const checkoutBuyer = '/checkout/:sellerId(\\d+)';
export const checkoutPayment = '/checkout/payment/:orderId(\\d+)';
export const checkoutPaymentAnotherCard = `${checkoutPayment}/another-card`;
// Warning: hardcoded on backend!!
export const checkoutPaymentStatus = `${checkoutPayment}/status`;
export const checkoutAddNewPaymentCard = '/checkout/payment/new-card';

// Checkout auth
export const checkoutAuthLogin = '/checkout/:productId(\\d+)/auth/login';
export const checkoutAuthRegistration = '/checkout/:productId(\\d+)/auth/registration';
export const checkoutAuthRedirect = '/checkout/:productId(\\d+)/auth/redirect';

// Checkout seller
export const checkoutSeller = '/my/sales/sale/:id/checkout';
export const checkoutSellerAddNewPaymentCard = `${checkoutSeller}/new-card`;

export const swapCollection = '/swap-party';
export const swapBuyerCheckout = '/swap-party/product/:productId(\\d+)/checkout';
export const swapBuyerCheckoutThanks = '/swap-party/thread/:threadId(\\d+)/thanks';
export const swapSellerCheckout = '/swap-party/orders/:orderId(\\d+)/checkout';

// Service payment status
// Warning: hardcoded on backend!!
export const servicePaymentStatus = '/service-payment/:paymentId(\\d+)/status';

// Dynamic collections
export const collections = '/dynamic-collections/:slug';

// Looks collections
export const looksCollections = '/looks-collections';
export const looksCollection = '/looks-collections/:slug';

// Virtual Catalog
// May be used directly (without variable) to prevent
// replacement `/` on `%2F` in slug
export const virtualCatalog = '/vc/:virtualCatalogSlug';

// Static dynamic collections
export const dayDiscount = '/dynamic-collections/skidka-dnya';
export const newArrivals = '/new-arrivals';

// add here new data if added new root category SHAF-153
// Feed
// Feed links may be used directly (without variable) to prevent
// replacement `/` on `%2F` in slug
export const baseCatalog = '/:namespace(women|kids|men|home|cosmetics|clothes|forkids|sport|aksesuary|electronics|auto|pet|garden|building)';
export const baseCatalogIndexedFilter = `${baseCatalog}/if/:indexedFilter`;
export const baseCatalogBrand = `${baseCatalog}/brand-:brand([a-zA-z0-9\\-]+)`;
export const baseCatalogCity = `${baseCatalog}/gorod-:city([a-zA-z0-9\\-]+)`;
export const catalog = `${baseCatalog}/:slug(.+)`;
export const catalogIndexedFilter = `${catalog}/if/:indexedFilter`;
export const catalogBrand = `${catalog}/brand-:brand([a-zA-z0-9\\-]+)`;
export const catalogCity = `${catalog}/gorod-:city([a-zA-z0-9\\-]+)`;

// Utility url to generate indexed filter path for both baseCatalog and catalog
// Same url pattern using on backend sitemap generation
export const indexedFilter = '/:base(.+)/if/:indexedFilter';

// Product
export const productReviews = `${productDetails}/reviews`;

// Saved search redirect
export const savedSearchRedirect = '/saved-search-redirect/:id';
export const autoSavedSearchRedirect = '/autosearch/:id';

// Bank id
// Those urls are used on backend as well
export const identificationUrl = '/api/v3/idgov/identify';
export const bankIdFailVerification = '/bank-id/verify-fail';
export const bankIdFailDuplicateVerification = '/bank-id/verify-duplicate';
export const bankIdSuccessVerification = '/bank-id/verify-success';

// Landings
export const mobileAppsLanding = '/lp/apps';
export const safePaymentLanding = '/lp/safe-payment/:role(for-seller|for-buyer)';
export const smartLanding = '/lp/smart';
export const swapLanding = '/lp/swap-party';

// Pages
export const secondaryPage = '/page/:slug';
export const aboutReviews = '/page/otzyvy-v-shafe';
export const partnerProgram = '/page/partnerskaya-programma';
export const contacts = '/page/kontakty';
export const howLogin = '/page/vhid-po-loginu-i-parolyu';
export const safePurchase = '/page/programma-zashity-pokupatelej#navigate-content';

// Terms
export const termsOfService = '/terms-of-service';
export const privacyPolicy = '/privacy-policy';

// social
export const social = '/social';
export const socialFeed = '/social/posts';
export const socialSimilarFeed = '/social/posts/:postId';
export const socialSavedFeed = '/social/saved';
export const socialProductFeed = '/social/product/:productId';
export const socialAddPost = '/social/add';
export const socialAddPostThanks = '/social/add/thanks';

// bank account identification
export const bankAccountIdentification = '/bank-account';
export const bankAccountIdentificationPending = '/bank-account/pending';

// brands
export const brands = '/brands';
